import './ExperienceBar.scss';
import template from './ExperienceBar.vhtml';

export default {
	name: 'ExperienceBar',
	template: template,
	props: {
		'years': {
			type: String,
			default: 1,
		},
		'max': {
			type: Number,
			default: 20,
		},
	},
	computed: {
		percentage: function () {
			if (this.years.indexOf('+') !== -1) {
				return '100%';
			}

			const intVal = parseInt(this.years);
			const pct = intVal / this.max * 100;
			return pct > 100 ? '100%' : pct + '%';
		},
	},
};
